import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { DisplayMode } from '@r-core';

/**
 * Menu item for adding an appliance via the countertop or panel context menu when SKU layer is active.
 * This allows users to add top-only/front-top items in overhead view.
 *
 * Visibility conditions:
 * - Not in readonly mode
 * - In overhead display mode
 * - SKU layer is active
 *
 * Uses the cursor X position (local to island) for initial placement.
 */
export const addApplianceSkuLayerMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Add Appliance',
		displayModes: [DisplayMode.SkuOverhead, DisplayMode.SkuOverheadManufacturing],
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ context, position, refMap, controller }): void => {
			console.log('menuitem:add-appliance-sku-layer:handler', context, position, refMap);

			// Determine the target panel ID based on context type
			let targetPanelId = context.id;

			// If the context is a countertop, get the front panel ID from the island
			if (refMap?.type === BlueprintInstanceType.Countertop && refMap?.countertop) {
				// Get the island from the countertop's islandIds
				const islandId = refMap.countertop.islandIds?.[0];
				if (islandId) {
					const island = controller.kitchen?.design?.islands?.findById(islandId);
					if (island) {
						targetPanelId = island.panels.frontPanelId;
					}
				}
			}
			// If the context is a panel, use the panel ID directly
			else if (refMap?.type === BlueprintInstanceType.Panel && refMap?.panel) {
				targetPanelId = refMap.panel.id;
			}

			// Publish the action with position information
			// The position.x contains the local X coordinate where the user clicked
			controller.publishRequestedAction('add_appliance', targetPanelId, {
				position
			});
		}
	};
};
